/**
 * External Dependencies
 */
import classnames from 'classnames'; //npm install classnames --save

/* https://jeffreycarandang.com/extending-gutenberg-core-blocks-with-custom-attributes-and-controls/ */

/**
 * WordPress Dependencies
 */
const { __ } = wp.i18n;
const { addFilter } = wp.hooks;
const { Fragment }	= wp.element;
//const { InspectorAdvancedControls }	= wp.blockEditor;
const { InspectorControls }	= wp.blockEditor;
const { createHigherOrderComponent } = wp.compose;
const { PanelBody, ToggleControl } = wp.components;

//restrict to specific block names
const allowedBlocks = [ 'core/image' ];

/**
 * Add custom attribute for stretching the row background color.
 *
 * @param {Object} settings Settings for the block.
 *
 * @return {Object} settings Modified settings.
 */
function addAttributes( settings ) {

    //check if object exists for old Gutenberg version compatibility
    //add allowedBlocks restriction
    if( typeof settings.attributes !== 'undefined' && allowedBlocks.includes( settings.name ) ){

        settings.attributes = Object.assign( settings.attributes, {
            blocksolidImageAlignFull:{
                type: 'boolean',
                default: false
            }
        });

    }

    return settings;
}

/**
 * Add column margin controls on Advanced Block Panel.
 *
 * @param {function} BlockEdit Block edit component.
 *
 * @return {function} BlockEdit Modified block edit component.
 */
const withAdvancedControls = createHigherOrderComponent( ( BlockEdit ) => {
    return ( props ) => {

        const {
            name,
            attributes,
            setAttributes,
            isSelected,
        } = props;

        const {
            blocksolidImageAlignFull,
        } = attributes;


        return (
            <Fragment>
                <BlockEdit {...props} />
                { isSelected && allowedBlocks.includes( name ) &&
                    <InspectorControls>
                    <PanelBody>
                        <ToggleControl
                            label={ __( 'Fill container (if unaligned)' ) }
                            checked={ !! blocksolidImageAlignFull }
                            onChange={ () => setAttributes( {  blocksolidImageAlignFull: ! blocksolidImageAlignFull } ) }
                            help={ !! blocksolidImageAlignFull ? __( 'Stretched to fill container (if unaligned).' ) : __( 'Not stretched to fill container (if unaligned).' ) }
							__nextHasNoMarginBottom={ true }
                        />
                    </PanelBody>
                    </InspectorControls>
                }

            </Fragment>
        );
    };
}, 'withAdvancedControls');

/* Apply the adjustment in the editor too */  // https://wordpress.stackexchange.com/questions/324091/
const withColumnMargins = createHigherOrderComponent( ( BlockListBlock ) => {
    return ( props ) => {

    if ( allowedBlocks.includes( props.name )) {
        if (props.attributes.blocksolidImageAlignFull){
            //return <BlockListBlock { ...props } className={ 'alignfull' } />;
            return <BlockListBlock { ...props } className={classnames( props.className, 'alignfull' )} />;
        } else {
        	return <BlockListBlock {...props} />
       	}
    } else {
           	return <BlockListBlock {...props} />
    }

    };
}, 'withClientIdClassName' );

wp.hooks.addFilter( 'editor.BlockListBlock', 'pwd-blocks/with-client-id-class-name', withColumnMargins )


/**
 * Add custom element class in save element.
 *
 * @param {Object} extraProps     Block element.
 * @param {Object} blockType      Blocks object.
 * @param {Object} attributes     Blocks attributes.
 *
 * @return {Object} extraProps Modified block element.
 */
function applyExtraClass( extraProps, blockType, attributes ) {

    const { blocksolidImageAlignFull } = attributes;

    //check if attribute exists for old Gutenberg version compatibility
    //add class only when blocksolidImageAlignFull = false
    //add allowedBlocks restriction
    if ( typeof blocksolidImageAlignFull !== 'undefined' && blocksolidImageAlignFull && allowedBlocks.includes( blockType.name ) ) {
        extraProps.className = classnames( extraProps.className, 'alignfull' );
    }

    return extraProps;
}

//add filters

addFilter(
    'blocks.registerBlockType',
    'pwd-blocks/custom-attributes',
    addAttributes
);

addFilter(
    'editor.BlockEdit',
    'pwd-blocks/custom-advanced-control',
    withAdvancedControls
);

addFilter(
    'blocks.getSaveContent.extraProps',
    'pwd-blocks/applyExtraClass',
    applyExtraClass
);